import inputData from './inputData/branding-questionnaire';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'branding-questionnaire',
  title: 'Branding Questionnaire',
  description: 'Gather the insights you need to shape a strong brand identity and position yourself confidently in the market.',
  image: '/images/templates/branding-questionnaire.png',
  tags: ['get-feedback', 'marketing', 'product'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

